import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UseMetriportToast } from "../useMetriportToast";

const DEFAULT_DURATION = 2000;

const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // Cache data is considered stale after 5 minutes
        gcTime: 1000 * 60 * 5, // Inactive queries are garbage collected after 5 minutes
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
    },
    queryCache: new QueryCache({
      onError: (_, query) => {
        const toast = query.meta?.toast as UseMetriportToast;
        if (!toast || !query.meta?.errorMessage) return;
        const title = query.meta.errorMessage as string;
        const duration = (query.meta.toastDuration as number) ?? DEFAULT_DURATION;
        toast.error({ title, duration });
      },
      onSuccess: (_, query) => {
        const toast = query.meta?.toast as UseMetriportToast;
        if (!toast || !query.meta?.successMessage) return;
        const title = query.meta.successMessage as string;
        const duration = (query.meta.toastDuration as number) ?? DEFAULT_DURATION;
        toast.success({ title, duration });
      },
    }),
  });
};

export type { QueryClient };
export { QueryClientProvider, createQueryClient };
